import { Component, OnInit, Input } from '@angular/core';
import { LoadingController, ModalController, ToastController } from '@ionic/angular';
import { AgentesService } from 'src/app/services/agentes.service';
import { ChatService } from 'src/app/services/chat.service';
import { EstatusService } from 'src/app/services/estatus.service';
import { WhatsappService } from 'src/app/services/whatsapp.service';

@Component({
  selector: 'app-mdl-filtro',
  templateUrl: './mdl-filtro.page.html',
  styleUrls: ['./mdl-filtro.page.scss'],
})
export class MdlFiltroPage implements OnInit {
  @Input() dataInfo: any;
  @Input() arrFiltro: any;
  @Input() reporte: number;
  arrDatosAsig: any;
  nombreTipo: string;
  search: string;
  dataSelect: any;
  tipo: any;
  arrAgentes: any;
  arrRes: any;
  arrOrigen: any;
  arrConversion: any;
  arrTipoEnv: any;
  arrEstado: any;
  arrPlantillas: any;
  arrEquipos: any;
  arrNomForms: any;
  arrIdForms: any;
  constructor(
    private agenteServ: AgentesService,
    private whaServ: WhatsappService,
    private loadingController: LoadingController,
    public toastController: ToastController,
    private modal: ModalController,
    private estatusServ: EstatusService,
    private chatsService: ChatService
  ) {
    this.arrDatosAsig = [];
    this.dataSelect = {};
    this.tipo = '2';
    this.arrAgentes = [];
    this.arrRes = [];
    this.arrOrigen = [];
    this.arrConversion = [];
    this.arrTipoEnv = [];
    this.arrEstado = [];
    this.arrNomForms = [];
    this.arrIdForms = [];
  }

  ngOnInit() {
    // console.log(this.value);
    if (this.tipo == '1') {
      this.nombreTipo = 'Resultado';
      this.getResultados();
    } else if (this.tipo == '2') {
      this.nombreTipo = 'Agente';
      this.getAgentes();
    }
    // else if(this.tipo == 'Conversión'){
    //   this.getOrigenConversion();
    // } else {
    //   this.nombreTipo = 'Origen';
    //   this.getOrigen();
    // }
  }
  // getConversion() {
  //  throw new Error('Method not implemented.');
  //}

  busquedaAgente(ev) {
    this.search = ev.detail.value;
  }

  getTipoEnvio() {
    this.tipo = 6;
    this.mapTipoEnv();
  }

  selectItem(ev, tipo) {
    // console.log(ev, tipo);
    if (tipo == 1) {
      // console.log(this.arrFiltro);
      // this.arrFiltro.resultados.push(Number(ev.detail.value));

      if (this.arrFiltro.resultados.includes(ev.detail.value)) {
        if (!ev.detail.checked) {
          const arrR = this.arrFiltro.resultados;
          // console.log(arrR);
          this.arrFiltro.resultados = [];
          arrR.forEach(id => {
            if (id !== ev.detail.value) {
              this.arrFiltro.resultados.push(id);
              // console.log(id, Number(ev.detail.value));
            }
          });
        }
      } else {
        this.arrFiltro.resultados.push(ev.detail.value);
        this.mapResultado();
      }

    } else if (tipo == 2) {
      if (this.arrFiltro.agentes.includes(Number(ev.detail.value))) {
        if (!ev.detail.checked) {
          const arrA = this.arrFiltro.agentes;
          this.arrFiltro.agentes = [];
          arrA.forEach(id => {
            if (id !== Number(ev.detail.value)) {
              this.arrFiltro.agentes.push(id);
              // console.log(id, Number(ev.detail.value));
            }
          });
        }
      } else {
        this.arrFiltro.agentes.push(Number(ev.detail.value));
        this.mapAgentes();
      }
    } else if (tipo == 3) {
      // this.arrFiltro.origen.push(ev.detail.value);
      if (this.arrFiltro.origen.includes(ev.detail.value)) {
        if (!ev.detail.checked) {
          const arrO = this.arrFiltro.origen;
          this.arrFiltro.origen = [];
          arrO.forEach(origen => {
            if (origen !== ev.detail.value) {
              this.arrFiltro.origen.push(origen);
              // console.log(id, Number(ev.detail.value));
            }
          });
        }
      } else {
        this.arrFiltro.origen.push(ev.detail.value);
        this.mapOrigen();
      }
    } else if (tipo == 4) {
      if (this.arrFiltro.plantillas.includes(Number(ev.detail.value))) {
        if (!ev.detail.checked) {
          const arrP = this.arrFiltro.plantillas;
          this.arrFiltro.plantillas = [];
          arrP.forEach(id => {
            if (id !== Number(ev.detail.value)) {
              this.arrFiltro.plantillas.push(id);
              // console.log(id, Number(ev.detail.value));
            }
          });
        }
      } else {
        this.arrFiltro.plantillas.push(Number(ev.detail.value));
        this.mapPlantillas();
      }
    } else if (tipo == 5) {
      if (this.arrFiltro.equipo.includes(Number(ev.detail.value))) {
        if (!ev.detail.checked) {
          const arrE = this.arrFiltro.equipo;
          this.arrFiltro.equipo = [];
          arrE.forEach(id => {
            if (id !== Number(ev.detail.value)) {
              this.arrFiltro.equipo.push(id);
              // console.log(id, Number(ev.detail.value));
            }
          });
        }
      } else {
        this.arrFiltro.equipo.push(Number(ev.detail.value));
        this.mapEquipos();
      }
    } else if (tipo == 6) {
      // this.arrFiltro.origen.push(ev.detail.value);
      if (this.arrFiltro.tipoEnv.includes(ev.detail.value)) {
        if (!ev.detail.checked) {
          const arrTip = this.arrFiltro.tipoEnv;
          this.arrFiltro.tipoEnv = [];
          arrTip.forEach(tipoEn => {
            if (tipoEn !== ev.detail.value) {
              this.arrFiltro.tipoEnv.push(tipoEn);
              // console.log(id, Number(ev.detail.value));
            }
          });
        }
      } else {
        this.arrFiltro.tipoEnv.push(ev.detail.value);
        this.mapOrigen();
      }
    }

    else if (tipo == 7) {
      if (this.arrFiltro.estado.includes(ev.detail.value)) {
        if (!ev.detail.checked) {
          const arrEst = this.arrFiltro.estado;
          this.arrFiltro.estado = [];
          arrEst.forEach(tipoEst => {
            if (tipoEst !== ev.detail.value) {
              this.arrFiltro.estado.push(tipoEst);
              // console.log(id, Number(ev.detail.value));
            }
          });
        }
      } else {
        this.arrFiltro.estado.push(ev.detail.value);
        this.mapEstado();
      }

    } else if (tipo == 8) {
      if (this.arrFiltro.conversion.includes(ev.detail.value)) {
        if (!ev.detail.checked) {
          const arrO = this.arrFiltro.conversion;
          this.arrFiltro.conversion = [];
          arrO.forEach(conversion => {
            if (conversion != ev.detail.value) {
              this.arrFiltro.conversion.push(conversion);
              // console.log(id, Number(ev.detail.value));
            }
          });
        }
      } else {
        this.arrFiltro.conversion.push(ev.detail.value);
        this.mapConversion();
      }
    } else if (tipo == 9) {
      // this.arrFiltro.origen.push(ev.detail.value);
      if (this.arrFiltro.nombre_form.includes(ev.detail.value)) {
        if (!ev.detail.checked) {
          const arrO = this.arrFiltro.nombre_form;
          this.arrFiltro.nombre_form = [];
          arrO.forEach(nombre_form => {
            if (nombre_form !== ev.detail.value) {
              this.arrFiltro.nombre_form.push(nombre_form);
              // console.log(id, Number(ev.detail.value));
            }
          });
        }
      } else {
        this.arrFiltro.nombre_form.push(ev.detail.value);
        this.mapNombreForms();
      }
    } else if (tipo == 10) {
      // this.arrFiltro.origen.push(ev.detail.value);
      if (this.arrFiltro.id_formulario.includes(ev.detail.value)) {
        if (!ev.detail.checked) {
          const arrO = this.arrFiltro.id_formulario;
          this.arrFiltro.id_formulario = [];
          arrO.forEach(id_formulario => {
            if (id_formulario !== ev.detail.value) {
              this.arrFiltro.id_formulario.push(id_formulario);
              // console.log(id, Number(ev.detail.value));
            }
          });
        }
      } else {
        this.arrFiltro.id_formulario.push(ev.detail.value);
        this.mapIdForms();
      }
    }
    // console.log(this.arrFiltro.agentes);
    // console.log(this.arrFiltro);
  }

  mapAgentes() {
    // console.log(this.arrFiltro.agentes);
    this.arrAgentes = this.arrDatosAsig.map((agente) => {
      let checked;
      // console.log(this.arrFiltro.agentes.includes(agente.id));
      if (this.arrFiltro.agentes.includes(agente.id)) {
        checked = true;
      } else {
        checked = false;
      }
      return {
        agente,
        checked
      };
    });
    // console.log(arr);
  }

  mapResultado() {
    this.arrRes = this.arrDatosAsig.map((res) => {
      let checked;
      // console.log(this.arrFiltro.agentes.includes(agente.id));
      if (this.arrFiltro.resultados.includes(res.estatus)) {
        checked = true;
      } else {
        checked = false;
      }
      return {
        res,
        checked
      };
    });
  }

  mapOrigen() {
    this.arrOrigen = this.arrDatosAsig.map((or) => {
      let checked;
      // console.log(this.arrFiltro.agentes.includes(agente.id));
      if (this.arrFiltro.origen.includes(or.origen)) {
        checked = true;
      } else {
        checked = false;
      }
      return {
        or,
        checked
      };
    });
  }

  mapConversion() {
    this.arrConversion = this.arrDatosAsig.map((conversion) => {
      let checked;
      // console.log(this.arrFiltro.agentes.includes(agente.id));
      if (this.arrFiltro.conversion.includes(conversion.value)) {
        checked = true;
      } else {
        checked = false;
      }
      return {
        conversion,
        checked
      };
    });
    console.log(this.arrConversion, this.arrFiltro, 'conversion')
  }

  mapTipoEnv() {
    const arrTip = ['masivo', 'individual'];
    this.arrTipoEnv = arrTip.map((tipo) => {
      let checked;
      // console.log(this.arrFiltro.agentes.includes(agente.id));
      if (this.arrFiltro.tipoEnv.includes(tipo)) {
        checked = true;
      } else {
        checked = false;
      }
      return {
        tipo,
        checked
      };
    });
  }

  mapEstado() {
    const arrEsta = ['0', '1'];
    this.arrEstado = arrEsta.map((estado) => {
      let checked;
      // console.log(this.arrFiltro.agentes.includes(agente.id));
      if (this.arrFiltro.estado.includes(estado)) {
        checked = true;
      } else {
        checked = false;
      }
      return {
        estado,
        checked
      };
    });
  }

  mapPlantillas() {
    this.arrPlantillas = this.arrDatosAsig.map((plantilla) => {
      let checked;
      // console.log(this.arrFiltro.agentes.includes(agente.id));
      if (this.arrFiltro.plantillas.includes(plantilla.id)) {
        checked = true;
      } else {
        checked = false;
      }
      return {
        plantilla,
        checked
      };
    });
  }

  mapEquipos() {
    this.arrEquipos = this.arrDatosAsig.map((equipo) => {
      let checked;
      // console.log(this.arrFiltro.agentes.includes(agente.id));
      if (this.arrFiltro.equipo.includes(equipo.id)) {
        checked = true;
      } else {
        checked = false;
      }
      return {
        equipo,
        checked
      };
    });
  }

  mapNombreForms() {

    this.arrNomForms = this.arrDatosAsig.map((or) => {
      let checked;
      // console.log(this.arrFiltro.agentes.includes(agente.id));
      if (this.arrFiltro.nombre_form.includes(or.nombre_form)) {
        checked = true;
      } else {
        checked = false;
      }
      return {
        or,
        checked
      };
    });

  }

  mapIdForms() {
    this.arrIdForms = this.arrDatosAsig.map((or) => {
      let checked;
      // console.log(this.arrFiltro.agentes.includes(agente.id));
      if (this.arrFiltro.id_formulario.includes(or.id_formulario)) {
        checked = true;
      } else {
        checked = false;
      }
      return {
        or,
        checked
      };
    });
  }

  async getAgentes() {
    this.tipo = '2';
    this.nombreTipo = 'Agente';
    await this.presentLoading('Cargando...');
    this.agenteServ.getAgentes(this.dataInfo.canale.idAdmin_sec, this.dataInfo.id, this.dataInfo.rol,
      this.dataInfo.token, this.dataInfo.canale.url_back).subscribe(
      (res: any)=>{
      // console.log(res);
      this.loadingController.dismiss();
        const {status, message} = res;
        if(status ==='success'){
         const {agentes} = res;
        //  console.log(agentes);
         this.arrDatosAsig = agentes;
         this.mapAgentes();
        }
        else{
         this.alertToast('', 'No se encontrarón Agentes', 'danger');
        }
    },
    erro => {
      console.log(erro);
      this.loadingController.dismiss();
      this.alertToast('Intenta más tarde', 'Error al cargar los Agentes', 'danger');
    });
  }

  async getResultados() {
    this.nombreTipo = 'Resultado';
    this.tipo = '1';
    await this.presentLoading('Cargando...');
    this.estatusServ.getAllEstatus(this.dataInfo.canale.idAdmin_sec, this.dataInfo.id, this.dataInfo.rol,
      this.dataInfo.token, this.dataInfo.canale.url_back).subscribe((res: any)=>{
        this.loadingController.dismiss();
        const { status, listaEstatus } = res;
        if (status === 'success') {
          this.arrDatosAsig = listaEstatus;
          this.arrDatosAsig.push({
            estatus: 'Abandono de Cliente'
          },
            {
              estatus: 'No Atendido'
            });
          this.mapResultado();
          //  console.log('lista de estatus',this.arrDatosAsig);
        } else {
          this.alertToast('', 'No se encontrarón Agentes', 'danger');
        }
      },
        erro => {
          console.log(erro);
          this.loadingController.dismiss();
          this.alertToast('Intenta más tarde', 'Error al cargar los Agentes', 'danger');
        }
      );
  }

  async getOrigen() {
    this.nombreTipo = 'Origen';
    this.tipo = '3';
    await this.presentLoading('Cargando...');
    if (this.reporte == 3) {
      this.arrDatosAsig = [{
        id_admin: this.dataInfo.canale.idAdmin_sec,
        origen: 'facebook'
      },{
        id_admin: this.dataInfo.canale.idAdmin_sec,
        origen: 'web'
      }];
      await this.loadingController.dismiss();
      this.mapOrigen();
    } else {
      this.chatsService.consultarOrigenes(this.dataInfo.canale.idAdmin_sec, this.dataInfo.id, this.dataInfo.rol,
        this.dataInfo.token, this.dataInfo.canale.url_back).subscribe(async(res: any)=>{
          await this.loadingController.dismiss();
          const { status, origenes } = res;
          if (status === 'success') {
            this.arrDatosAsig = origenes;
            this.mapOrigen();
            //  console.log('lista de origenes',this.arrDatosAsig);
          } else {
            this.alertToast('', 'No se encontrarón Agentes', 'danger');
          }
        },
          erro => {
            console.log(erro);
            this.loadingController.dismiss();
            this.alertToast('Intenta más tarde', 'Error al cargar los Agentes', 'danger');
          }
        );
    }
  }

  async getNombreForms() {
    this.nombreTipo = 'Nombre Forms';
    this.tipo = 9;
    await this.presentLoading('Cargando...');

    this.chatsService.consultarNombresForms(this.dataInfo.canale.idAdmin_sec, this.dataInfo.id, this.dataInfo.rol,
        this.dataInfo.token).subscribe(async(res: any)=>{
          await this.loadingController.dismiss();
               const {status, nombre_forms} = res;
               if(status ==='success'){
                 this.arrDatosAsig = nombre_forms;
                 this.mapNombreForms();
                //  console.log('lista de nombre_forms',this.arrDatosAsig);
               } else{
                this.alertToast('', 'No se encontrarón Agentes', 'danger');
               }
        },
        erro => {
          console.log(erro);
          this.loadingController.dismiss();
          this.alertToast('Intenta más tarde', 'Error al cargar los Agentes', 'danger');
        }
      );
  }

  async getIdForms() {
    this.tipo = 10;
    this.nombreTipo = 'Id Forms';
    await this.presentLoading('Cargando...');

    this.chatsService.consultarIdsForms(this.dataInfo.canale.idAdmin_sec, this.dataInfo.id, this.dataInfo.rol,
        this.dataInfo.token).subscribe(async(res: any)=>{
          await this.loadingController.dismiss();
               const {status, id_forms} = res;
               if(status ==='success'){
                 this.arrDatosAsig = id_forms;
                 this.mapIdForms();
                //  console.log('lista de id_forms',this.arrDatosAsig);
               } else{
                this.alertToast('', 'No se encontrarón Agentes', 'danger');
               }
        },
        erro => {
          console.log(erro);
          this.loadingController.dismiss();
          this.alertToast('Intenta más tarde', 'Error al cargar los Agentes', 'danger');
        }
      );
  }

  async getOrigenConversion() {
    this.nombreTipo = 'Conversión';
    this.tipo = '8';
    await this.presentLoading('Cargando...');
      this.arrDatosAsig = [{
        id_admin: this.dataInfo.canale.idAdmin_sec,
        conversion: 'Con respuesta',
        value: '1'
      },{
        id_admin: this.dataInfo.canale.idAdmin_sec,
        conversion: 'Sin respuesta',
        value: '0'
      }];
      this.mapConversion();
      await this.loadingController.dismiss();
      
  }

  async getPlantillas() {
    this.nombreTipo = 'Plantilla';
    this.tipo = '4';
    await this.presentLoading('Cargando...');
    this.chatsService.consultaPlantillasStatus(this.dataInfo.canale.idAdmin_sec, this.dataInfo.id, this.dataInfo.rol,
      this.dataInfo.token, 1, 1, 1, this.dataInfo.canale.url_back).subscribe(async (res: any)=>{
        await this.loadingController.dismiss();
        const { status, plantillas } = res;
        if (status === 'success') {
          this.arrDatosAsig = plantillas;
          this.mapPlantillas();
          //  console.log('lista de origenes',this.arrDatosAsig);
        } else {
          this.alertToast('', 'No se encontrarón Agentes', 'danger');
        }
      },
        erro => {
          console.log(erro);
          this.loadingController.dismiss();
          this.alertToast('Intenta más tarde', 'Error al cargar los Agentes', 'danger');
        }
      );
  }

  async getEquipos() {
    this.nombreTipo = 'Equipo';
    this.tipo = '5';
    await this.presentLoading('Cargando...');
    this.whaServ.getSucursales(this.dataInfo.canale.idAdmin_sec, this.dataInfo.id, this.dataInfo.rol,
      this.dataInfo.token, this.dataInfo.canale.url_back).subscribe(async (res: any)=>{
        await this.loadingController.dismiss();
        const { status, sucursales } = res;
        if (status === 'success') {
          this.arrDatosAsig = sucursales;
          this.mapEquipos();
          //  console.log('lista de origenes',this.arrDatosAsig);
        } else {
          this.alertToast('', 'No se encontrarón Agentes', 'danger');
        }
      },
        erro => {
          console.log(erro);
          this.loadingController.dismiss();
          this.alertToast('Intenta más tarde', 'Error al cargar los Agentes', 'danger');
        }
      );
  }

  async getEstadoChat() {
    this.nombreTipo = 'Estado de chat';
    this.tipo = '7';
    this.mapResultado();
  }


  select(ev, tipo) {
    // console.log(ev.detail.value);
  }

  exit() {
    console.log(this.arrFiltro);
    this.modal.dismiss({
      filtro: this.arrFiltro
    });
  }

  async presentLoading(message) {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message,
      // duration: 2000
    });
    await loading.present();
  }

  async alertToast(header, mensaje, color) {
    const toast = await this.toastController.create({
      header,
      message: mensaje,
      position: 'bottom',
      // cssClass: 'animate__animated animate__fadeInUp',
      color,
      //icon:'checkmark-outline',
      duration: 6000,
      // buttons: [
      //   {
      //     side: 'end',
      //     icon: 'mail-unread-outline',
      //     text: 'Nuevo',

      //   },
      // ]
    });
    await toast.present();
    const { role } = await toast.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

}
